import { render, staticRenderFns } from "./AccreditationBuilderContainer.vue?vue&type=template&id=c7e5c4ac&scoped=true"
import script from "./AccreditationBuilderContainer.vue?vue&type=script&lang=js"
export * from "./AccreditationBuilderContainer.vue?vue&type=script&lang=js"
import style0 from "./AccreditationBuilderContainer.vue?vue&type=style&index=0&id=c7e5c4ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e5c4ac",
  null
  
)

export default component.exports